import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=6d0536b8"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0536b8')) {
      api.createRecord('6d0536b8', component.options)
    } else {
      api.reload('6d0536b8', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=6d0536b8", function () {
      api.rerender('6d0536b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/partials/footer.vue"
export default component.exports